import {IStateStore} from '../../ap-interface';
import {Store}       from '../index';
import {Injectable}  from '@angular/core';
import {
  ActiveUsersGlobalLogout,
  ActiveUsersKick,
  ActiveUsersLoad,
  ActiveUsersLoadSuccess,
  NetTypes
}                    from 'invoker-transport';
import IActiveUser = Data.Authentication.IActiveUser;
import {ApSignalrService} from '../../ap-core/services/ap-signalr.service';
import {ApBase64Util} from '../../ap-utils/static/ap-base64-util';

@Injectable({providedIn: 'root'})
export class ActiveUsersStore extends Store<IStateStore<IActiveUser>> {
  constructor(public backend: ApSignalrService) {
    super(backend, {
      loaded: false,
      loading: false,
      data: []
    });

    backend.registerObservable(ActiveUsersLoadSuccess).subscribe(d => {
      super.Mutate(s => s.data, () => d.Data);
      super.SetLoadFinishState();
    });
  }

  public loadActiveUsers(): void {
    super.SetLoadState();
    super.Mutate(d => d.data, () => []);
    this.DispatchBackend(new ActiveUsersLoad());
  }

  public refreshActiveUsers(): void {
    this.DispatchBackend(new ActiveUsersLoad());
  }

  public kickUser(userId: number): void {
    this.DispatchBackend(new ActiveUsersKick(
      [{Name: 'userId', Type: NetTypes.INT, Value: userId}]));
  }

  public globalLogoutUser(username: string, password: string): void {

    this.DispatchBackend(new ActiveUsersGlobalLogout(
      [
        {Name: 'username', Type: NetTypes.STRING, Value: username},
        {Name: 'password', Type: NetTypes.STRING, Value: ApBase64Util.stringToBase64(password)}]));
  }
}
